export default __webpack_public_path__ + "static/media/image_demo_behavioral_health.7252ead4.svg";